import React, { Component } from 'react';
import { cloneDeep } from 'lodash';
import { Form, Input, Modal } from 'antd';
import Resources from '../scripts/resources';
import Rules from '../scripts/rules';

class PackageForm extends Component {
    constructor() {
        super();

        this.state = {};

        this.formRef = React.createRef();
    }

    handleSubmit = () => {
        this.formRef.current.validateFields().then(values => {
            this.props.onSubmit(values);
        });
    }

    handleWillUnmount = () => {
        this.formRef.current.resetFields();
    }

    handleDidMount = (data = {}) => {
        this.formRef.current.setFieldsValue(cloneDeep(data));
        this.setState({ editMode: !!data.id });
    }

    render() {
        const { onCancel, submitting, visible } = this.props;
        const { editMode } = this.state;

        return (
            <Modal
                title={editMode ? Resources.edit : Resources.add}
                visible={visible}
                onOk={this.handleSubmit}
                onCancel={onCancel}
                okText={Resources.confirm}
                cancelText={Resources.cancel}
                okButtonProps={{ loading: submitting }}
                cancelButtonProps={{ disabled: submitting }}
                width={360}>
                <Form ref={this.formRef} layout="vertical">
                    <Form.Item name="title" label={Resources.title} rules={Rules.required}>
                        <Input type="text" />
                    </Form.Item>
                    <Form.Item name="count" label={Resources.count} rules={Rules.required}>
                        <Input type="text" />
                    </Form.Item>
                </Form>
            </Modal>
        );
    }
};

export default PackageForm;